import { render, staticRenderFns } from "./EditItemDialog.vue?vue&type=template&id=41a10022&"
import script from "./EditItemDialog.vue?vue&type=script&lang=js&"
export * from "./EditItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports